// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].use[2]!../variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\---ui-components-src-input---ImageInput-module__container-wrapper {
  position: relative;
}

.\\---ui-components-src-input---ImageInput-module__container {
  position: relative;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  border: 1px solid currentColor;
  color: currentColor;
  border-radius: var(--mechanic-input-height-half);
  padding: 0 var(--mechanic-input-height) 0 var(--mechanic-input-height-quart);
  display: flex;
  align-items: center;
  min-height: var(--mechanic-input-height);
  line-height: 1;
  background-color: var(--mechanic-background);
  font-size: inherit;
  font-family: inherit;
  font-weight: inherit;
  width: 100%;
}

.\\---ui-components-src-input---ImageInput-module__loadedImages {
  z-index: 21;
  pointer-events: none;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  flex-grow: 1;
}

.\\---ui-components-src-input---ImageInput-module__imageItem {
  pointer-events: initial;
  margin: 0.15em 0.15em 0 0;
}

.\\---ui-components-src-input---ImageInput-module__thumbnail {
  max-height: var(--mechanic-input-height-half);
  max-width: 150px;
  border-radius: 3px;
}

.\\---ui-components-src-input---ImageInput-module__preview {
  position: absolute;
  z-index: 100;
  left: var(--mechanic-input-height-quart);
  right: var(--mechanic-input-height-quart);
  margin-top: var(--mechanic-input-height-quart);
  width: calc(100% - var(--mechanic-input-height-half));
  max-height: 200px;
  -o-object-fit: contain;
     object-fit: contain;
  background-color: #f7f7f7;
  border-radius: 8px;
}

.\\---ui-components-src-input---ImageInput-module__input {
  opacity: 0;
  width: 0.1px;
  height: 0.1px;
  position: absolute;
  outline: none;
}

.\\---ui-components-src-input---ImageInput-module__browseButton {
  position: absolute;
  left: 0;
  right: 0;
  z-index: 20;
  padding: 0 var(--mechanic-input-height-half) 0 0;
  height: 100%;
  width: 100%;
  border: none;
  outline: none;
  border-radius: var(--mechanic-input-height-half);
  background: none;
  color: inherit;
  vertical-align: middle;
  text-align: right;
  cursor: pointer;
}

.\\---ui-components-src-input---ImageInput-module__focus .\\---ui-components-src-input---ImageInput-module__container {
  outline: none;
  border: 2px solid currentColor;
  padding-left: calc(var(--mechanic-input-height-quart) - 1px);
}
.\\---ui-components-src-input---ImageInput-module__focus .\\---ui-components-src-input---ImageInput-module__browseButton {
  padding-right: calc(var(--mechanic-input-height-half) - 1px);
}

.\\---ui-components-src-input---ImageInput-module__focus .\\---ui-components-src-input---ImageInput-module__container .\\---ui-components-src-input---ImageInput-module__preview {
  left: calc(var(--mechanic-input-height-quart) - 1px);
  right: calc(var(--mechanic-input-height-quart) - 1px);
}

.\\---ui-components-src-input---ImageInput-module__invalid {
}

.\\---ui-components-src-input---ImageInput-module__disabled {
  opacity: 0.4;
}

.\\---ui-components-src-input---ImageInput-module__disabled .\\---ui-components-src-input---ImageInput-module__browseButton {
  cursor: default;
}

.\\---ui-components-src-input---ImageInput-module__container:not([disabled]):hover {
}

.\\---ui-components-src-input---ImageInput-module__container:active {
  transform: translateY(1px);
}

.\\---ui-components-src-input---ImageInput-module__plus {
  margin-top: 0.2em;
}
`, "",{"version":3,"sources":["webpack://./../ui-components/src/input/ImageInput.module.css"],"names":[],"mappings":"AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,8BAA8B;EAC9B,mBAAmB;EACnB,gDAAgD;EAChD,4EAA4E;EAC5E,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,cAAc;EACd,4CAA4C;EAC5C,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;EAC7C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;EACxC,yCAAyC;EACzC,8CAA8C;EAC9C,qDAAqD;EACrD,iBAAiB;EACjB,sBAAmB;KAAnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,gDAAgD;EAChD,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gDAAgD;EAChD,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,4DAA4D;AAC9D;AACA;EACE,4DAA4D;AAC9D;;AAEA;EACE,oDAAoD;EACpD,qDAAqD;AACvD;;AAEA;AACA;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;AACA;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["@import \"../variables.css\";\n\n.container-wrapper {\n  position: relative;\n}\n\n.container {\n  position: relative;\n  z-index: 10;\n  display: flex;\n  justify-content: space-between;\n  border: 1px solid currentColor;\n  color: currentColor;\n  border-radius: var(--mechanic-input-height-half);\n  padding: 0 var(--mechanic-input-height) 0 var(--mechanic-input-height-quart);\n  display: flex;\n  align-items: center;\n  min-height: var(--mechanic-input-height);\n  line-height: 1;\n  background-color: var(--mechanic-background);\n  font-size: inherit;\n  font-family: inherit;\n  font-weight: inherit;\n  width: 100%;\n}\n\n.loadedImages {\n  z-index: 21;\n  pointer-events: none;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  flex-grow: 1;\n}\n\n.imageItem {\n  pointer-events: initial;\n  margin: 0.15em 0.15em 0 0;\n}\n\n.thumbnail {\n  max-height: var(--mechanic-input-height-half);\n  max-width: 150px;\n  border-radius: 3px;\n}\n\n.preview {\n  position: absolute;\n  z-index: 100;\n  left: var(--mechanic-input-height-quart);\n  right: var(--mechanic-input-height-quart);\n  margin-top: var(--mechanic-input-height-quart);\n  width: calc(100% - var(--mechanic-input-height-half));\n  max-height: 200px;\n  object-fit: contain;\n  background-color: #f7f7f7;\n  border-radius: 8px;\n}\n\n.input {\n  opacity: 0;\n  width: 0.1px;\n  height: 0.1px;\n  position: absolute;\n  outline: none;\n}\n\n.browseButton {\n  position: absolute;\n  left: 0;\n  right: 0;\n  z-index: 20;\n  padding: 0 var(--mechanic-input-height-half) 0 0;\n  height: 100%;\n  width: 100%;\n  border: none;\n  outline: none;\n  border-radius: var(--mechanic-input-height-half);\n  background: none;\n  color: inherit;\n  vertical-align: middle;\n  text-align: right;\n  cursor: pointer;\n}\n\n.focus .container {\n  outline: none;\n  border: 2px solid currentColor;\n  padding-left: calc(var(--mechanic-input-height-quart) - 1px);\n}\n.focus .browseButton {\n  padding-right: calc(var(--mechanic-input-height-half) - 1px);\n}\n\n.focus .container .preview {\n  left: calc(var(--mechanic-input-height-quart) - 1px);\n  right: calc(var(--mechanic-input-height-quart) - 1px);\n}\n\n.invalid {\n}\n\n.disabled {\n  opacity: 0.4;\n}\n\n.disabled .browseButton {\n  cursor: default;\n}\n\n.container:not([disabled]):hover {\n}\n\n.container:active {\n  transform: translateY(1px);\n}\n\n.plus {\n  margin-top: 0.2em;\n}\n"],"sourceRoot":""}]);
// Exports
export var containerWrapper = `---ui-components-src-input---ImageInput-module__container-wrapper`;
export var container = `---ui-components-src-input---ImageInput-module__container`;
export var loadedImages = `---ui-components-src-input---ImageInput-module__loadedImages`;
export var imageItem = `---ui-components-src-input---ImageInput-module__imageItem`;
export var thumbnail = `---ui-components-src-input---ImageInput-module__thumbnail`;
export var preview = `---ui-components-src-input---ImageInput-module__preview`;
export var input = `---ui-components-src-input---ImageInput-module__input`;
export var browseButton = `---ui-components-src-input---ImageInput-module__browseButton`;
export var focus = `---ui-components-src-input---ImageInput-module__focus`;
export var invalid = `---ui-components-src-input---ImageInput-module__invalid`;
export var disabled = `---ui-components-src-input---ImageInput-module__disabled`;
export var plus = `---ui-components-src-input---ImageInput-module__plus`;
export default ___CSS_LOADER_EXPORT___;
